import React, { useState } from "react";
//lib
import { useSelector } from "react-redux";
import { getData } from "common-lib/lib";
// styled
import { Wf, BlockCol } from "../CommonRule/Rule";
import styled from "styled-components";

const WfStyled = styled(Wf)`
  ${props => props.imgSrc.indexOf("main_game_feature") > -1 && `
      height: auto !important;
  `}
  ${props => props.imgSrc.indexOf("main_game_feature") > -1 && `
    img {
      max-width: 100% !important;
    }
  `}
`;

const RuleWrapper = styled.div`
  img{
    max-height: 120px !important;
  }
`;

const Rule = ({
  rule,
  createContent,
  gameId,
  windowDimensions,
  lang,
  sify,
  tify,
}) => {
  const imgsdomain = useSelector((state) => state.props.imgsdomain);
  const [isHorizontal, setIsHorizontal] = useState(true);
  const onLoad = (e) => {
    const ratio = e.target.naturalHeight / e.target.naturalWidth;
    if (ratio > 1.2) {
      setIsHorizontal(false);
    }
  };
  const imgSrc = `${imgsdomain}/vp_project/common/${gameId}/symbolList/${getData(
    rule,
    ["icon", "link"]
  )}.png`;
  return (
    <>
      {getData(rule, ["title"]) !== "+" && <hr />}
      <BlockCol windowDimensions={windowDimensions}>
        {getData(rule, ["title"]) !== "+" && (
          <p className="title">
            {lang === "zh-tw"
              ? tify(getData(rule, ["title"]))
              : lang === "cn"
              ? sify(getData(rule, ["title"]))
              : getData(rule, ["title"])}
          </p>
        )}
        {getData(rule, ["icon", "link"]) && (
          <WfStyled img={getData(rule, ["icon", "link"])} isHorizontal={isHorizontal} imgSrc={imgSrc}>
            <img
              className="object-fit-scale mb20 h100"
              alt=""
              onLoad={(e) => onLoad(e)}
              src={imgSrc}
            />
          </WfStyled>
        )}

        <RuleWrapper className="rules">
          <div
            dangerouslySetInnerHTML={createContent(
              getData(rule, ["content"]),
              gameId,
              imgsdomain
            )}
          />
        </RuleWrapper>
      </BlockCol>
    </>
  );
};

const Rules = (props) => {
  const { helpData } = props;
  // const newHelpData = getData(helpData, ["data"]).filter((rule) => rule?.["icon"]?.["link"] !== "random_wild");
  const newHelpData = getData(helpData, ["data"]);
  return (
    <>
      {newHelpData.map((rule, k) => {
        return <Rule rule={rule} key={k} {...props} />
      })}
    </>
  );
};

export default Rules;
